import type { QueryResult } from '@apollo/react-common';
import { useQuery } from '@apollo/react-hooks';
import type { IssueId } from '@atlassian/jira-shared-types/src/general.tsx';
import type {
	jira_deploymentFrequencyReportDeploymentDetails_issueDetails_Query as DeploymentFrequencyReportIssueDetailsQuery,
	jira_deploymentFrequencyReportDeploymentDetails_issueDetails_QueryVariables as DeploymentFrequencyReportIssueDetailsQueryVariables,
} from './__generated_apollo__/jira_deploymentFrequencyReportDeploymentDetails_issueDetails_Query';
import { ISSUE_DETAILS_QUERY } from './gql.tsx';
import type { Issue, User, ServiceResult } from './types.tsx';
import { buildQueryVariables, transformResult } from './utils.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { Issue, User };

export const useIssues = (issueIds: IssueId[]): ServiceResult<Issue[]> => {
	const queryResult: QueryResult<
		DeploymentFrequencyReportIssueDetailsQuery,
		DeploymentFrequencyReportIssueDetailsQueryVariables
	> = useQuery(ISSUE_DETAILS_QUERY, {
		variables: { ...buildQueryVariables(issueIds) },
		errorPolicy: 'all',
	});

	return transformResult(queryResult);
};
